"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _dist = require("kubra-ux/dist");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SplashScreen = function SplashScreen() {
  var metadata = (0, _reactRedux.useSelector)(function (state) {
    var _state$metadataReduce;

    return (_state$metadataReduce = state.metadataReducer.metadata) === null || _state$metadataReduce === void 0 ? void 0 : _state$metadataReduce.directory;
  });

  if (!metadata) {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: 'splash-screen-container'
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: 'splash-screen-message'
    }, /*#__PURE__*/_react.default.createElement(_dist.LoadingAnimation, {
      strokeColor: "url(#gradient)",
      strokeWidth: "10%"
    }), /*#__PURE__*/_react.default.createElement("span", null, "Loading")));
  }

  return /*#__PURE__*/_react.default.createElement("div", null, "\xA0");
};

var _default = SplashScreen;
exports.default = _default;